import {
    AfterViewInit,
    Component,
    ElementRef,
    Input,
    OnDestroy,
    OnInit,
    Renderer2,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { BlurEvent, ChangeEvent, CKEditorComponent } from '@ckeditor/ckeditor5-angular';
import { Subscription } from 'rxjs';
import * as ClassicEditor from '../../../assets/ckeditor-classic/build/ckeditor';
import { KeyValuePair } from '../../shared/shared.types';
import { BaseInputComponent } from '../base-input/base-input.component';
import { RichTextInputType } from '../form.types';
import { QuestionStateService } from '../question-state.service';

@Component({
    selector: 'app-rich-text-input',
    templateUrl: './rich-text-input.component.html',
    styleUrls: ['./rich-text-input.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class RichTextInputComponent extends BaseInputComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() input: RichTextInputType;
    public editor = ClassicEditor;
    @ViewChild('divWrapper') divWrapper: ElementRef;
    @ViewChild('editorComponent') editorComponent: CKEditorComponent;
    private subscription: Subscription;
    public initialData: string;
    gotTags: boolean;
    private tags$: Subscription;
    tags: KeyValuePair[];

    constructor(protected renderer2: Renderer2, private questionStateService: QuestionStateService) {
        super();
    }

    ngOnInit(): void {
        this.initialize(this.input, this.questionStateService);
        this.initialData = this.convertFromDbText(this.input.control.value);
        // remove the insert image toolbar option for now. It looks like the resize image is broken
        // also images get classes applied instead of inline styles which needs some attention in order to
        // show them in email etc.
        const index = this.editor.defaultConfig.toolbar.items.indexOf('insertImage');
        if (index >= 0) {
            // this.editor.defaultConfig.toolbar.items.splice(index, 1);
        }
        if (this.input.droppableTags) {
            this.tags$ = this.input.droppableTags.subscribe({
                next: (tags) => {
                    if (tags && tags.length > 0) {
                        tags.forEach((tag) => {
                            tag.key = tag.key.replace(/\{|}|&#123;|&#125;/g, '');
                            tag.key = this.reflection.toTitleCase(tag.key);
                        });
                        this.tags = tags;
                        this.gotTags = true;
                    }
                },
                error: () => {}
            });
        }
    }

    ngAfterViewInit() {
        this.subscription = this.input.control.valueChanges.subscribe((value: string) => {
            this.applyErrorClass(this.hasError());
            if (value) {
                this?.editorComponent?.editorInstance?.setData(value);
            }
        });
    }

    applyErrorClass(hasError: boolean) {
        if (!this.divWrapper) {
            return;
        }
        if (hasError) {
            this.renderer2.addClass(this.divWrapper.nativeElement, 'rich-text-error');
        } else {
            this.renderer2.removeClass(this.divWrapper.nativeElement, 'rich-text-error');
        }
    }

    convertFromDbText(text: string) {
        if (!text) {
            return text;
        }
        return text.replace(/><br\/><\/p>/g, '>&nbsp;</p>');
    }

    convertToDbText(text: string) {
        if (!text) {
            return text;
        }
        return text.replace(/>&nbsp;<\/p>/g, '><br/></p>');
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        if (this.tags$) {
            this.tags$.unsubscribe();
        }
    }

    focus() {
        if (this.divWrapper) {
            this.divWrapper.nativeElement.querySelector('.ck.ck-content').focus();
        }
    }

    setControlSilently(text: string) {
        this.input.control.setValue(this.convertToDbText(text), { emitEvent: false });
    }

    editorChange($event: ChangeEvent) {
        this.storeData($event.editor);
    }

    editorBlur($event: BlurEvent) {
        this.storeData($event.editor);
        this.blurEvent(null);
        this.applyErrorClass(this.hasError());
    }

    storeData(editor: any) {
        if (editor) {
            const data = editor.getData();
            this.setControlSilently(data);
        }
    }

    dragstart($event: DragEvent, tag: KeyValuePair) {
        $event.dataTransfer.setData('text/plain', tag.value);
    }

    over($event: DragEvent) {
        $event.preventDefault();

    }
}
